// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"ba77f4fc","163":"d839d996","385":"e8aea89a","438":"6f464544","640":"74e972a0","672":"c97056a0","714":"4a87c1ca","719":"e56e5b60","869":"5e98ffbd","998":"5c366dc9"}[chunkId] + ".chunk.js";
};